import React from 'react';
import { ModelFactory, Toolbar } from '@leverege/ui-plugin';
import { connect } from 'react-redux';
import { ValuesCache } from '@leverege/value-cache';
import { Flex } from '@leverege/ui-elements';
import { ToolbarContext } from '@leverege/ui-dashboard';
import { GroupDelegate } from '@leverege/molten-core';
import ResponsiveView from "../responsive/ResponsiveView.js";
import AggsViewModel from "./models/AggsViewModel.js";
import AggregationPaginator from "./AggregationsPaginator.js";
import S from './AggregationsContainerView.css';
import { AggResultProcessorFactory } from "./models/resultsProcessors/index.js";
import { HeaderToolbar } from "../Util.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const REFRESH_TIME = 30000;
class AggregationsContainerView extends React.Component {
  static contextType = ToolbarContext;
  constructor(props) {
    super(props);
    const {
      settings
    } = props;
    this.timer = null;
    this.isInError = false;
    this.Model = ModelFactory.get(AggsViewModel.getAggregation(settings));
    this.paginator = new AggregationPaginator();
    this.cache = new ValuesCache();
  }
  componentDidMount() {
    this.loadData();
  }
  componentDidUpdate(prevProps) {
    const {
      settings
    } = this.props;
    const {
      settings: pSettings
    } = prevProps;
    if (settings !== pSettings) {
      this.loadData();
    }
  }
  componentWillUnmount() {
    clearTimeout(this.timer);
  }
  loadData = async () => {
    if (this.isInError) return;
    clearTimeout(this.timer);
    const {
      delegate,
      dispatch,
      settings,
      objectType
    } = this.props;
    if (!this.Model) {
      return;
    }
    try {
      await dispatch(delegate.search({
        aggs: {
          agg: this.Model.toImagineAgg(AggsViewModel.getAggregation(settings), {
            objectType
          })
        },
        limit: 0
      }));
    } catch (err) {
      this.isInError = true;
    }
    this.timer = setTimeout(this.loadData, REFRESH_TIME);
  };
  getContext = dataViewerType => {
    return {
      client: AggregationsContainerView.CLIENT,
      dataViewerType,
      clientProps: {
        ...this.props
      }
    };
  };
  createDataItems = (items, loading) => {
    const {
      delegate,
      relationship,
      settings
    } = this.props;
    const query = AggsViewModel.getAggregation(settings);
    let results = [];
    if (items?.aggs) {
      results = AggResultProcessorFactory.create(`aggregationResultProcessor.${items?.aggOptions?.agg?.type}`, items.aggs.agg, query, {
        delegate,
        relationship,
        options: items.aggOptions.agg
      }) || [];
    }
    return {
      loading,
      status: items?.status,
      error: items?.error,
      perPage: results.length,
      page: 0,
      count: results.length,
      items: results
    };
  };
  rendererHeader = dataViewerModel => {
    if (dataViewerModel == null) {
      return null;
    }
    const {
      relationship: {
        path
      },
      objectType,
      inCard
    } = this.props;
    const actionBarMatchContext = {
      use: 'actionBar',
      client: AggregationsContainerView.CLIENT,
      dataViewerType: dataViewerModel.type,
      objectType,
      path
    };
    const filterBarMatchContext = {
      use: 'filterBar',
      client: AggregationsContainerView.CLIENT,
      dataViewerType: dataViewerModel.type,
      objectType,
      path
    };
    const context = this.getContext(dataViewerModel.type);
    const content = /*#__PURE__*/_jsxs(Flex, {
      className: inCard ? undefined : S.toolbars,
      variant: "aggregationsToolbar",
      children: [/*#__PURE__*/_jsx(Toolbar, {
        variant: "filterBar|actionBar",
        matchContext: filterBarMatchContext,
        context: context
      }), /*#__PURE__*/_jsx(Toolbar, {
        variant: "actionBar",
        prefer: "icon",
        matchContext: actionBarMatchContext,
        context: context
      })]
    });
    return /*#__PURE__*/_jsx(HeaderToolbar, {
      inCard: inCard,
      content: content
    });
  };
  render() {
    const {
      items,
      loading,
      settings,
      objectType
    } = this.props;
    const context = this.getContext(null);
    const dataItems = this.cache.calc('items', this.createDataItems, items, loading);
    this.paginator.setData(dataItems);
    const query = AggsViewModel.getAggregation(settings);
    return /*#__PURE__*/_jsx(ResponsiveView, {
      ...this.props,
      objectType: "aggResult",
      context: context,
      paginator: this.paginator,
      query: query,
      sourceObjectType: objectType,
      useContentView: true,
      contentHeader: this.rendererHeader
    });
  }
}
export default connect((state, props) => {
  const {
    delegate: pActions,
    dataViewerInstanceId
  } = props;
  const delegate = new GroupDelegate({
    match: pActions.match,
    relationship: pActions.relationship,
    ...pActions.options,
    queryName: `${dataViewerInstanceId.current}.aggregations`,
    ttl: 30000
  });
  return {
    delegate,
    items: delegate.getList(state, {
      getAll: true
    }),
    loading: delegate.isLoading(state)
  };
})(AggregationsContainerView);
AggregationsContainerView.CLIENT = 'AggregationsContainerView';